// Interface for activity data
export interface UserActivity {
  _id: string;
  createdAt: string;
  updatedAt: string;
  eventType: ActivityEventType;
  user: string;
  project: string;
  ticket: string;
  category: activityTypeEnum;
  meta: {
    title: string;
    createdBy: string;
    teamName: string;
    userEmail: string;
    projectName: string;
    ticketId: string;
    newDueDate:string;
  };
  teamMemberId: string;
  timestamp: string;
}

export type UserActivityFilters = {
  q: string;
  activityTypeIds: string[];
  projectIds: string[];
};

export enum ActiveTabEnum {
  Active = "activity",
  MemberDetails = "memberDetails",
}

export enum UserStatusEnum {
  ONLINE = "online",
  OFFLINE = "offline",
  NOT_ACTIVE = "not_active",
}

export type UpdateUserStatus = {
  status: UserStatusEnum;
};

export type UserActivityMeta = {
  page: number;
  perPage: number;
};

export type FetchActivitiesRequest = { memberId: string };
export type FetchActivitiesResponse = {
  data: UserActivity[];
  meta: UserActivityMeta;
};

export enum ActivityEventType {
  // Member-related events
  MEMBER_ADDED = "Member Added",
  MEMBER_REMOVED = "Member Removed",
  MEMBER_ROLE_UPDATED = "Member Role Updated",
  MEMBER_LOGGED_IN = "Member Logged In",
  MEMBER_LOGGED_OUT = "Member Logged Out",
  MEMBER_ONLINE_STATUS_CHANGED = "Member Online Status Changed",
  MEMBER_ENABLED_2FA = "Member Enabled 2FA",
  MEMBER_DISABLED_2FA = "Member Disabled 2FA",
  MEMBER_PASSWORD_RESET = "Member Password Reset",
  MEMBER_PROFILE_UPDATED = "Member Profile Updated",
  // Team-related events
  TEAM_NAME_CHANGED = "Team Name Changed",
  TEAM_FEATURE_ADDED = "Team Feature Added",
  TEAM_FEATURE_REMOVED = "Team Feature Removed",
  TEAM_MEMBER_ADDED = "Team Member Added",
  // Status-related events
  STATUS_ADDED = "Status Added",
  STATUS_REMOVED = "Status Removed",
  STATUS_PARAMETER_CHANGED = "Status Parameter Changed",
  // Workflow-related events
  WORKFLOW_CREATED = "Workflow Created",
  WORKFLOW_SET_AS_DEFAULT = "Workflow Set as Default",
  // Project-related events
  MEMBER_ADDED_TO_PROJECT = "Member Added to Project",
  MEMBER_REMOVED_FROM_PROJECT = "Member Removed from Project",
  NEW_PROJECT_CREATED = "New Project Created",
  PROJECT_NAME_UPDATED = "Project Name Updated",
  PROJECT_STATUS_UPDATED = "Project Status Updated",
  // Ticket-related events
  TICKET_CREATED = "Ticket Created",
  TICKET_UPDATED = "Ticket Updated",
  TICKET_ARCHIVED = "Ticket Archived",
  TICKET_STATUS_UPDATED = "Ticket Status Updated",
  COMMENT_ADDED = "Comment Added",
  COMMENT_DELETED = "Comment Deleted",
  COMMENT_UPDATED = "Comment Updated",
  ATTACHMENT_UPLOADED = "Attachment Uploaded",
  ATTACHMENT_DELETED = "Attachment Deleted",
  TICKET_PRIORITY_UPDATED = "Ticket Priority Updated",
  TICKET_TITLE_UPDATED = "Ticket Title Updated",
  TICKET_TYPE_UPDATED = "Ticket Type Updated",
  TICKET_TAG_UPDATED = "Ticket Tag Updated",
  TICKET_ASSIGNEE_UPDATED = "Ticket Assignee Updated",
  TICKET_DUE_DATE_UPDATED = "Ticket Due Date Updated",
  PROJECT_CREATED = "Project Created",
  //ARCHIVE_TICKET
  ARCHIVE_TICKET_TAG = "Archive Ticket Tag",
  ARCHIVE_TICKET_STATUS = "Archive Ticket Status",
  ARCHIVE_BOARD = "Archive Board",
  ARCHIVE_PROJECT = "Archive Project",
  // Sprint-related events
  SPRINT_STATUS_UPDATED = "Sprint Status Updated",
  NEW_SPRINT_CREATED = "New Sprint Created",
  // Time tracking-related events
  TIME_ENTRY_ADDED = "Time Entry Added",
  TIME_ENTRY_CHANGED = "Time Entry Changed",
  TIME_ENTRY_DELETED = "Time Entry Deleted",
  TIME_TRACKING_STARTED = "Time Tracking Started",
  TIME_TRACKING_STOPPED = "Time Tracking Stopped",
  // Board-related events
  NEW_BOARD_CREATED = "New Board Created",
  BOARD_SETTINGS_SAVED = "Board Settings Saved",
  COMMENT_REPLIED = "Comment Replied",
}

export enum activityTypeEnum {
  TICKET = "ticket",
  PROJECT = "project",
  WORKFLOW = "workflow",
  RELEASES = "releases",
  SPRINT = "sprint",
  ARCHIVE = "archive",
  BOARDS = "boards",
  TIME_TRACKING = "time tracking",
  IMPORT_EXPORT = "import/export",
  TEAM_MEMBERS = "team member",
}
// Define the shape of the state for UserDetails
export interface UserState {
  loading: boolean;
  error: string | null;
  selectedMemberId: string;
  drawerPayload?: any;
  activities: {
    filters: UserActivityFilters;
    data: UserActivity[];
    meta: UserActivityMeta;
    loading: boolean;
  };
  activeTab: ActiveTabEnum;
  userStatus: UserStatusEnum | null;
}
